<template>
  <div id="sellerOption">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="留言时间">
        <el-date-picker
          style="width: 350px"
          size="mini"
          v-model="searchForm.leaveTimeRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="onSearch('1')">今天</el-button>
        <el-button size="mini" @click="onSearch('2')">本周</el-button>
        <el-button size="mini" @click="onSearch('3')">本月</el-button>
      </el-form-item>
      <el-form-item label="奖励积分">
        <el-select style="width: 100px" size="mini" v-model="searchForm.isAward" placeholder="请选择">
          <el-option
            v-for="item in awardOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="deleteAll">批量删除</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="sellerHeadPic" label="头像">
        <template slot-scope="scope">
          <el-avatar size="small" :src="scope.row.sellerHeadPic"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="sellerName" label="用户名"></el-table-column>
      <el-table-column prop="title" label="标题" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="type" label="类型" width="100">
        <template slot-scope="scope">
          {{ scope.row.type === 1 ? '功能异常' : scope.row.type === 2 ? '建议反馈' : '其他' }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="反馈内容" width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="leaveTime" label="留言时间" :formatter="dateFormatter"></el-table-column>
      <el-table-column prop="readTime" label="审阅时间" :formatter="dateFormatter"></el-table-column>
      <el-table-column prop="awardCredits" label="奖励积分"></el-table-column>
      <el-table-column
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="awardCredits(scope.row)"
            type="text"
            size="small">
            奖励积分
          </el-button>
          <el-button
            @click.native.prevent="deleteOption(scope.row.id)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>

    <el-dialog
      title="奖励积分"
      :visible.sync="dialogVisible"
      @close="closeAwardDialog"
      width="30%">
      <el-input v-model="awardCreditsValue" type="number" placeholder="请输入积分额"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAwardDialog">取 消</el-button>
        <el-button type="primary" @click="awardCreditsSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "seller-option",
    data(){
      return{
        searchForm:{
          leaveTimeRange:"",
          keyWords:"",
          isAward:null,
          tab:null //1今天，2本周，3本月
        },
        awardOption:[{
          label:"有",
          value:1
        },{
          label:"无",
          value:0
        }],
        multipleSelection:[],
        selectIds:[],
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        dialogVisible:false,
        awardCreditsValue:null,
        awardId:null
      }
    },
    created(){
      this.getData();
    },
    methods:{
      //获取表格数据
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.tableData = response.data.list
            this.pageInfo.total = response.data.total;
          }
        }
        if(this.tab){
          let date = new Date();
          if(this.tab == 1){
            let startDate = new Date(date.getFullYear(),date.getMonth(),date.getDate(),0,0,0)
            let endDate = new Date(date.getFullYear(),date.getMonth(),date.getDate(),23,59,59)
            this.searchForm.leaveTimeRange = [utils.dateFormat(startDate,"yyyy-MM-dd HH:mm:ss"),utils.dateFormat(endDate,"yyyy-MM-dd HH:mm:ss")]
          }else if(this.tab == 2){
            let startDate = utils.getWeekStartAndEnd(date)[0];
            let endDate = utils.getWeekStartAndEnd(date)[1];
            startDate = new Date(startDate.getFullYear(),startDate.getMonth(),startDate.getDate(),0,0,0)
            endDate = new Date(endDate.getFullYear(),endDate.getMonth(),endDate.getDate(),23,59,59)
            this.searchForm.leaveTimeRange = [utils.dateFormat(startDate,"yyyy-MM-dd HH:mm:ss"),utils.dateFormat(endDate,"yyyy-MM-dd HH:mm:ss")];
          }else if(this.tab == 3){
            let startDate = utils.getMonthStartAndEnd(date)[0];
            let endDate = utils.getMonthStartAndEnd(date)[1];
            startDate = new Date(startDate.getFullYear(),startDate.getMonth(),startDate.getDate(),0,0,0)
            endDate = new Date(endDate.getFullYear(),endDate.getMonth(),endDate.getDate(),23,59,59)
            this.searchForm.leaveTimeRange = [utils.dateFormat(startDate,"yyyy-MM-dd HH:mm:ss"),utils.dateFormat(endDate,"yyyy-MM-dd HH:mm:ss")];
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:"/api/sellerOption/query",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            leaveTimeStart:this.searchForm.leaveTimeRange?this.searchForm.leaveTimeRange[0]:"",
            leaveTimeEnd:this.searchForm.leaveTimeRange?this.searchForm.leaveTimeRange[1]:"",
            isAward:this.searchForm.isAward,
            keyWords:this.searchForm.keyWords
          },
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      //搜索
      onSearch(tab){
        if(tab){
          this.tab = tab;
        }
        this.getData();
      },
      //批量删除
      deleteAll(){
        let id = this.selectIds.join(",")
        this.deleteOption(id)
      },
      //奖励积分
      awardCredits(row){
        this.dialogVisible = true;
        this.awardId = row.id;
      },
      //关闭奖励积分
      closeAwardDialog(){
        this.dialogVisible = false;
        this.awardId = null;
        this.awardCreditsValue = null;
      },
      //单行删除
      deleteOption(id){
        utils.axiosMethods({
          method:"POST",
          url:"/api/sellerOption/deleteById",
          params:{
            id:id
          },
          callback:(res =>{
            if(res.data.code == 0){
              this.$message({
                message: '恭喜你，删除成功',
                type: 'success'
              });
              this.getData();
            }
          })
        })
      },
      //表格多选改变事件
      handleSelectionChange(val) {
        this.multipleSelection = val;
        let ids = [];
        val.map(item => {
          ids.push(item.id)
        });
        this.selectIds = ids;
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      // 日期格式化
      dateFormatter(row, column, cellValue, index){
        return utils.dateFormat(cellValue)
      },
      // 奖励积分提交
      awardCreditsSure(){
        utils.axiosMethods({
          method:"POST",
          url:"/api/sellerOption/awardCredit",
          params:{
            id:this.awardId,
            credit:this.awardCreditsValue
          },
          callback:(res =>{
            if(res.data.code == 0){
              this.$message({
                message: '恭喜你，奖励积分成功',
                type: 'success'
              });
              this.closeAwardDialog();
              this.getData();
            }
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #sellerOption{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sellerOption.vue